export default __webpack_public_path__ + "static/media/8.6c6f6a87.jpg";